import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL as string | undefined;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY as string | undefined;

// Create a client only if env vars exist; otherwise a dummy with minimal shape
let client: ReturnType<typeof createClient> | null = null;
if (supabaseUrl && supabaseAnonKey) {
  client = createClient(supabaseUrl, supabaseAnonKey, {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
    },
  });
}

export const supabase = client;

let exchangeAttempted = false;

// Ensure OAuth code/refresh_token in URL are exchanged for a session (needed for PKCE flows)
export const exchangeCodeIfPresent = async (): Promise<void> => {
  if (!client || typeof window === 'undefined') return;
  try {
    if (exchangeAttempted) return;
    const url = new URL(window.location.href);
    const code = url.searchParams.get('code');
    const refreshToken = url.searchParams.get('refresh_token');
    if (!code && !refreshToken) return;

    if (code) {
      await client.auth.exchangeCodeForSession(code);
    } else if (refreshToken) {
      await client.auth.refreshSession({ refresh_token: refreshToken });
    }

    // Clean the query params to avoid re-exchanging on refresh
    url.searchParams.delete('code');
    url.searchParams.delete('refresh_token');
    window.history.replaceState({}, document.title, url.pathname + url.search + url.hash);
    exchangeAttempted = true;
  } catch (e) {
    // swallow; the normal session check will handle failures
    console.warn('exchangeCodeIfPresent failed', e);
  }
};

export const getAccessToken = async (): Promise<string | null> => {
  if (!client) return null;
  try {
    if (!exchangeAttempted) {
      await exchangeCodeIfPresent();
    }
    const { data } = await client.auth.getSession();
    return data.session?.access_token || null;
  } catch {
    return null;
  }
};
